<!-- Content dashboard panel -->
<div class="charts-container" [class.in-synthesis]="!!scope">
    <!-- Widgets on the grid, in reading order -->
    <div class="dashboard-grid" data-testid="dashboard-grid" [style.--columns]="columns" [style.--row-height.px]="rowHeight"
        [class.fitted]="fitted()" [class.arranging]="!!gesture"
        [class.resizing]="!!gesture && gesture.handle !== 'move'" #grid>
        @for (item of gridItems; track item.id) {
        <div class="drag-box chart" [style.grid-area]="cells[item.id!]?.area" [style.borderColor]="borderColor"
            [class.active]="gesture?.id === item.id" (mouseenter)="showEdit(item)" (mouseleave)="hideEdit(item)">

            <!-- Move and resize handles -->
            @if (canArrange()) {
            <div class="drag-handle" (pointerdown)="startGesture($event, item, 'move')">
                <mat-icon>drag_indicator</mat-icon>
            </div>
            <div class="resize-handle e" (pointerdown)="startGesture($event, item, 'e')"></div>
            <div class="resize-handle s" (pointerdown)="startGesture($event, item, 's')"></div>
            <div class="resize-handle se" (pointerdown)="startGesture($event, item, 'se')"></div>
            }

            <app-widget-host #host [widget]="item" (exported)="onExport($event, item)" [inputs]="{
                width: cells[item.id!]?.width, height: cells[item.id!]?.height, filters: filters, refreshSignal: refreshSignal,
                signalSingled: item.signalSingled, visible: item.visible, projects: projects,
                tenantId: scope?.tenantId, excludeProjects: excludeProjects }">
            </app-widget-host>

            <!-- Synthesis: some projects of the tenant did not answer. -->
            <span class="partial" *ngIf="scope && host.instance?.failedSources?.length"
                [title]="failedNames(host.instance!.failedSources)">
                <mat-icon>warning</mat-icon>
                {{ 'synthesis.partial_data' | translate: { count: host.instance!.failedSources.length } }}
            </span>

            <!-- Buttons inside widget -->
            <div class="edit-buttons" *ngIf="item.showEdit">
                <ng-container *ngIf="item.type === 'chart'">
                    <lib-button *ngIf="isChartZoomed(item)" (click)="zoomBackChart(item)" color="none"
                        textColor="secondary" icon="undo" tooltip="{{ 'editor.zoomBack' | translate }}">
                    </lib-button>

                    <lib-button *ngIf="isChartZoomed(item)" (click)="resetZoomChart(item)" color="none"
                        textColor="secondary" icon="refresh" tooltip="{{ 'editor.resetZoom' | translate }}">
                    </lib-button>
                </ng-container>

                <lib-button *ngIf="canEditWidgets()" (click)="editWidget(item)" color="none" textColor="primary"
                    icon="edit" tooltip="{{ 'form.edit' | translate }}">
                </lib-button>

                <lib-button [matMenuTriggerFor]="moreMenu" color="none" textColor="muted" icon="more_horiz"
                    tooltip="{{ 'form.more_options' | translate }}" (menuOpened)="menuItem = item"
                    (menuClosed)="closeMenu(item)">
                </lib-button>

                <mat-menu #moreMenu="matMenu">
                    <button (click)="exportChart(item)" mat-menu-item>
                        <mat-icon color="primary">share</mat-icon>
                        <span>{{'editor.copy_image' | translate}}</span>
                    </button>
                    <button (click)="duplicateChart(item)" mat-menu-item *ngIf="!scope">
                        <mat-icon color="primary">content_copy</mat-icon>
                        <span>{{'form.duplicate' | translate}}</span>
                    </button>
                    <button (click)="refreshChart(item)" mat-menu-item>
                        <mat-icon color="primary">refresh</mat-icon>
                        <span>{{'form.refresh' | translate}}</span>
                    </button>

                    <button (click)="fullscreen(item)" mat-menu-item>
                        <mat-icon color="primary">fullscreen</mat-icon>
                        <span>{{'form.fullscreen' | translate}}</span>
                    </button>

                    <button (click)="confirmDeleteChart(item)" mat-menu-item class="danger" *ngIf="canDeleteWidgets()">
                        <mat-icon>delete</mat-icon>
                        <span>{{'form.delete' | translate}}</span>
                    </button>
                </mat-menu>
            </div>
        </div>
        }

        <!-- Target cell of the move or resize -->
        @if (ghost) {
        <div class="grid-ghost" [style.grid-area]="ghost"></div>
        }
    </div>

    <app-loading-popup *ngIf="exporting" [title]="'dashboard.pdf_generating' | translate" [totalStages]="widgetsCount"
        [currentStage]="currentStage" [stageTitle]="'dashboard.pdf_widgets' | translate">
    </app-loading-popup>
</div>
